import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Drawer from "@mui/material/Drawer";
import Container from "@mui/material/Container";
import { actionSearchVisibleToggled } from "./SearchRedux";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchInput from "./Input";
import Filter from "./Filters";
import Table from "./Table";
import { initialAPIPing, actionSearchPopulateDefaultData } from "./SearchRedux";
import UrlSearch from "./UrlSearch";
import { trackEvent } from "../../tracking";

const drawer_ = (theme) => ({
  width: "45vw",
  minWidth: 335,
  maxWidth: 600,
  height: "100vh",
  [theme.breakpoints.down("lg")]: {
    width: "80vw",
  },
  [theme.breakpoints.down("md")]: {
    width: "90vw",
  },
  [theme.breakpoints.down("sm")]: {
    width: "95vw",
  },
});

const container_ = (theme) => ({
  height: "100vh",
  padding: "5px 20px",
  [theme.breakpoints.down("sm")]: {
    padding: "0 5px 5px 5px",
  },
});

const hideBtn_ = (theme) => ({
  display: "none",
  padding: "5px",
  width: "100%",
  borderRadius: "0px",
  backgroundColor: "rgba(211, 211, 211, 0.5)",
  [theme.breakpoints.down("sm")]: {
    display: "block",
  },
});

export default function Search() {
  const isVisible = useSelector((state) => state.searchReducer.isVisible);
  const idToken = useSelector((state) => state.authReducer.idToken);
  const dispatch = useDispatch();

  useEffect(() => {
    !!idToken && initialAPIPing(idToken);
  }, [idToken]);

  useEffect(() => {
    !!idToken && dispatch(actionSearchPopulateDefaultData());
  }, [dispatch, idToken]);

  useEffect(() => {
    if (isVisible) {
      trackEvent({
        category: "Data Exploration",
        action: "Search",
      });
    }
  }, [isVisible]);

  const toggleDrawer = (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    dispatch(actionSearchVisibleToggled());
  };

  return (
    <Drawer
      anchor="bottom"
      open={isVisible}
      onClose={toggleDrawer}
      sx={drawer_}
      slotProps={{
        paper: {
          sx: drawer_,
        },
      }}
      ModalProps={{ keepMounted: true }}
    >
      <Container sx={container_}>
        <IconButton sx={hideBtn_} onClick={toggleDrawer} size="large">
          <ExpandMoreIcon />
        </IconButton>
        <SearchInput />
        <Filter />
        <Table />
        <UrlSearch />
      </Container>
    </Drawer>
  );
}
